import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import '../styles/ExclusiveListing.css'
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';


const properties = [
    {
      id: 1,
      status: "For Sale",
      image: "/assets/images/house1.avif",
      address: "1234 Elm St, Springfield, IL 62701",
      price: "$1,200,000",
      features: ["4 Bedrooms", "3 Bathrooms", "2,500 Sq.Ft."]
    },
    {
      id: 2,
      status: "Coming Soon",
      image: "/assets/images/house2.avif",
      address: "5678 Oak Dr, Chicago, IL 60601",
      price: "$3,500,000",
      features: ["6 Bedrooms", "5 Bathrooms", "4,000 Sq.Ft."]
    },
    {
      id: 3,
      status: "For Sale",
      image: "/assets/images/house3.avif",
      address: "7890 Pine Ave, Peoria, IL 61602",
      price: "$750,000",
      features: ["3 Bedrooms", "2 Bathrooms", "1,800 Sq.Ft."],
      openHouse: "Open House: 12/20/2024, 2:00 PM - 5:00 PM"
    },
    {
      id: 4,
      status: "Sold",
      image: "/assets/images/house4.avif",
      address: "2345 Maple Dr, Bloomington, IL 61701",
      price: "$950,000",
      features: ["4 Bedrooms", "3 Bathrooms", "2,200 Sq.Ft."]
    },
    {
      id: 5,
      status: "For Sale",
      image: "/assets/images/house3.avif",
      address: "3456 Cedar Ln, Springfield, IL 62702",
      price: "$1,500,000",
      features: ["5 Bedrooms", "4 Bathrooms", "3,000 Sq.Ft."]
    },
    {
      id: 6,
      status: "Coming Soon",
      image: "/assets/images/house2.avif",
      address: "4567 Birch Blvd, Decatur, IL 62521",
      price: "$2,200,000",
      features: ["6 Bedrooms", "5 Bathrooms", "3,800 Sq.Ft."]
    }
  ];
  
  

export const ExclusiveListing = () => {
  return (
    <div className='p-5 bg-dark text-white'>
        <p>Alex Turner Estates</p>
        <h1 className='display-5'>Exclusive Listings</h1>
    <div className="w-full relative mt-5">
      <Swiper
        className="multiple-slide-carousel"
        modules={[Navigation, Autoplay]} 
        loop={true}
        slidesPerView={3}
        spaceBetween={30}
        autoplay={{
          delay: 3000, 
          disableOnInteraction: false, 
        }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        breakpoints={{
          1920: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1028: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          990: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        }}
      >
        {properties.map((property) => (
        <SwiperSlide key={property.id}>
        <div className="d-flex flex-column">
              <img
                src={property.image}
                alt={property.address}
                className="rounded-2xl h-96 w-full object-cover"
                style={{ maxHeight: '500px' }}
              />
              {property.openHouse && (
                    <div className="open-house-label" style={{bottom:'180px'}}>
                    {property.openHouse}
                    </div>
                )}
              <div className="p-4 text-left">
                <h3>{property.address}</h3>
                <p>{property.price}</p>
                <p>
                  {property.features.length > 0 &&
                    property.features.map((feature, idx) => (
                      <span key={idx} className="d-inline-block mx-1">
                        {feature}
                      </span>
                    ))}
                </p>
              </div>
            </div>
        </SwiperSlide>
        ))}
        
      </Swiper>

      <div className="relative flex justify-center  items-center m-auto mt-5 left-2 right-2 w-fit bottom-12">
        <button
          className="swiper-button-prev group !pe-2 flex justify-center items-center !w-15 !h-15 transition-all duration-500 rounded-full hover:bg-indigo-600 !-translate-x-20"
        >
        </button>
        <button
          className="swiper-button-next group !ps-2 flex justify-center items-center  !w-15 !h-15 transition-all duration-500 rounded-full hover:bg-indigo-600 !translate-x-20"
        >
          
        </button>
        
        
      </div>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
      <Link to="/exclusiveListings"  className="link">View Properties</Link>
      </div>
    </div>
    </div>
  )
}
